import React, { useEffect, useState } from 'react';
import HelpBackIcon from './../../../../../images/helpbackicon.png'
import {Link, useNavigate} from 'react-router-dom'
import FAQPlusIcon from './../../../../../images/faqplus.png' 
import FAQMinusIcon from './../../../../../images/faqminus.png'
import {useTranslation} from 'react-i18next'

function ReleaseMusic() { 
    const [feedback,setFeedback] = useState(false)
    const navigate= useNavigate();
    const [faq1,setFaq1] = useState(false)
    const [faq2,setFaq2] = useState(false)
    const [faq3,setFaq3] = useState(false)
    const [faq4,setFaq4] = useState(false)
    const [faq5,setFaq5] = useState(false)
    const [faq6,setFaq6] = useState(false)
    const [faq7,setFaq7] = useState(false)
    const [faq8,setFaq8] = useState(false)
    const [faq9,setFaq9] = useState(false)
    const [faq10,setFaq10] = useState(false)
    const [faq11,setFaq11] = useState(false)
    const [faq12,setFaq12] = useState(false)
    const [faq13,setFaq13] = useState(false)
    const [faq14,setFaq14] = useState(false)
    const [faq15,setFaq15] = useState(false)
    const [faq16,setFaq16] = useState(false)
    const [faq17,setFaq17] = useState(false)
    const [faq18,setFaq18] = useState(false)
    const {t, i18n } = useTranslation();

    return (
        <div style={{backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/yovww6fxrbmtzfqlpy0z")`,backgroundPositionX:'-1em',backgroundSize:'100%'}}>

        <div style={{         
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        zIndex:'1',
        height:'9.63em'
        }}/>

        <div style={{
              backgroundColor:'#F9FCFF',
              width:'100%',
              display:'flex',
              flexDirection:'column',
              alignItems:'center',
              paddingBottom:'5.5em',
              minHeight: '72vh', height: 'auto'
        }}>
            <div style={{
                display:'flex',
                flexDirection:'column',
                alignItems:'flex-start',
                width:'70%',
                paddingTop:'2.5em'
            }}>

                <div style={{
                    display:'flex',
                    flexDirection:'row',
                    alignItems:'center',
                    cursor:'pointer'
                   
                }} onClick={()=>{navigate("/help");setFeedback(false)}}>
                    <img src={HelpBackIcon} style={{width:'1.5em',height:'1.5em',marginRight:'0.25em',cursor:'pointer'}}/>
                    <div className="backTxt">Back</div>
                </div>

                <div className="infoHeader">
                    Release Music
                </div>

                <div className="infoDescHeader">
                GENERAL INFO/FAQ
                </div>

                <div style={{display:'flex',flexDirection:'column',width:'100%',justifyContent:'flex-start',zIndex:'1'}}>

                 {
                      !faq1 && 
                      <div className="SupportFaq" style={{borderTop:'2px #000000 solid',cursor:'pointer',color:'#000000'}} onClick={()=>{setFaq1(!faq1);}}>
                         <div className="SupportFaqH2"> What platforms does N3RVE distribute music to?</div>
                      <img src={FAQPlusIcon} style={{width:'0.8em',height:'0.8em',right:'2em',top:'1.2em',position:'absolute'}}/>
                      </div>
                  }

                  {
                      faq1 && 
                      <div  style={{zIndex:'1'}}>
                          <div className="SupportFaq" style={{borderTop:'2px #000000 solid',color:'#000000'}}>
                             <div onClick={()=>setFaq1(!faq1)}  className="SupportFaqH2" style={{cursor:'pointer'}}>What platforms does N3RVE distribute music to?</div>
                              <div className="SupportFaqH3" style={{color:'#000000'}}>
                              N3rve distrubtes music to over 150 digital stores around the globe.<br/>
                               {/* Some of our main music partners are Spotify, Apple Music, Deezer, Amazon Music, Tidal, Beatport, Youtube Music, and TikTok Music. */}
                              {/* <span style={{color:'#C7A5FF',cursor:'pointer',fontWeight:'500'}}>here</span> (create site page like tunecores) to learn more about our digital distro landscape. */}
                              We distribute to: <br/>
                                {/* SoundCloud <br/>
                                Apple Music <br/>
                                Deezer <br/>
                                Amazon Music <br/>
                                Tidal <br/>
                                Beatport <br/>
                                Youtube Music <br/>
                                Tiktok Music <br/>
                                Spotify <br/>
                                AWA <br/>
                                Genie <br/>
                                Pandora <br/>
                                Joox <br/>
                                KKBox <br/>
                                Line Music<br/>
                                Melon <br/>
                                Qobuz <br/>
                                Rakuten Music <br/>
                                Tencent <br/> */}
                                7Digital <br/>
                                Amazon <br/>
                                Ami Entertainment <br/>
                                Anghami <br/>
                                Apple Music <br/>
                                AWA <br/>
                                Beatport <br/>
                                Beatsource <br/>
                                Bleep <br/>
                                Bmat <br/>
                                Boomplay <br/>
                                Bugs! <br/>
                                Deezer <br/>
                                Dreamus Company <br/>
                                Facebook Audio Library <br/>
                                Facebook Fingerprinting <br/>
                                Facebook Video <br/>
                                Facebook Video Fingerprinting <br/>
                                Feed.FM Adaptr <br/>
                                fizy <br/>
                                Genie Music <br/>
                                Gracenote <br/>
                                Hardstyle.com <br/>
                                HighResAudio <br/>
                                Hungama <br/>
                                iHeartRadio <br/>
                                iMusica / Claro SA <br/>
                                Jaxsta Music <br/>
                                JioSaavn <br/>
                                Joox <br/>
                                Kakao / MelOn <br/>
                                KkBox <br/>
                                Kuack Media <br/>
                                LINE Music <br/>
                                LyricFind <br/>
                                MePlaylist <br/>
                                Mixcloud <br/>
                                mora [HD] (A)<br/>
                                mora [SD] (A)<br/>
                                Music in 'Ayoba' <br/>
                                Muska <br/>
                                Napster <br/>
                                NAVER VIBE <br/>
                                NetEase Cloud Music <br/>
                                Nightlife Music Video <br/>
                                Nuuday A/S <br/>
                                orimyustore (A)<br/>
                                Pandora <br/>
                                Peloton <br/>
                                Pretzel Rocks <br/>
                                Qobuz <br/>
                                Shazam <br/>
                                Slacker <br/>
                                SoundCloud <br/>
                                Spotify <br/>
                                Spotify Video <br/>
                                Stellar Entertainment <br/>
                                Taobao <br/>
                                Tencent <br/>
                                TIDAL <br/>
                                TikTok <br/>
                                TikTok Music <br/>
                                TIM Music <br/>
                                TouchTunes <br/>
                                Trebel Music <br/>
                                U-NEXT (A)<br/>
                                United Media Agency (UMA) <br/>
                                VEVO <br/>
                                Xite <br/>
                                Yandex Music <br/>
                                YouTube Music &amp; Content ID <br/>
                                ZVOOQ <br/>
                                エムティーアイ [HD] (MTI) (A)<br/>
                                エムティーアイ [SD/MV] (MTI) (A)<br/>
                                オトトイ [HD] (OTOTOY) (A)<br/>
                                オトトイ [SD] (OTOTOY) (A)<br/>
                                オンキヨー [HD] (Onkyo) SHUTDOWN (A)<br/>
                                ドワンゴ (Dwango) (A)<br/>
                                フェイス (Faith) (A)<br/>
                                メディアドゥ (Media Do) (A)<br/> 
                                モンスターラボ (Monstar Lab) (A)<br/>
                                ヤマハ (YAMAHA) (A)<br/>
                                レコチョク [HD] (Recochoku) (A)<br/>
                                レコチョク [SD/MV] (Recochoku) (A)<br/>
                                楽天 (Rakuten) (A)<br/>
                              </div>
                              <img src={FAQMinusIcon} style={{width:'0.8em',height:'3px',right:'2em',top:'1.2em',position:'absolute',cursor:'pointer'}} onClick={()=>setFaq1(!faq1)}/>
                          </div>
                      </div>
                  }

                {
                      !faq2 && 
                      <div className="SupportFaq" onClick={()=>{setFaq2(!faq2);}} style={{cursor:'pointer'}}>
                     <div className="SupportFaqH2"> Do I need to own all of the rights to the music I’m selling?</div>
                      <img src={FAQPlusIcon} style={{width:'0.8em',height:'0.8em',right:'2em',top:'1.2em',position:'absolute'}}/>
                      </div>
                  }

                  {
                      faq2 && 
                      <div  style={{zIndex:'1'}}>
                          <div className="SupportFaq">
                             <div onClick={()=>setFaq2(!faq2)} style={{cursor:'pointer'}} className="SupportFaqH2">Do I need to own all of the rights to the music I’m selling?</div>
                              <div className="SupportFaqH3" style={{color:'#000000'}}>
                              Yes! It is very important to own the rights or permissions to the music you are submitting or else you may be subject to copyright infringement and legal repercussions. 
                              </div>
                              <div className="SupportFaqH2">LICENSING</div>
                              <div className="SupportFaqH3">In order to distribute on N3RVE, you must either own the copyright for the sound recordings & compositions, or have the authority or permission from the owner(s). You can obtain these usage rights by obtaining licenses, which will be required for your music uploads & submissions in order to be approved for distribution.</div>
                              <div className="SupportFaqH3">The same goes for any samples that are used in your music uploads and submissions. They must all be legally cleared and/or paid-for. No "mix tapes" of other people's music, even if you are mixing in your own music. You will need to supply documentation of your license agreements, or your receipt for its purchase.</div>
                              <div className="SupportFaqH3">We also recommend that you</div>
                              <div className="SupportFaqH2">USCO (US Copyright Office)</div>
                              <div className="SupportFaqH3">As an artist, we recommend that you register your works with the US Copyright Office (USCO) to protect your rights in case of any violations.</div>
                              <div className="SupportFaqH3">Although registering is highly recommended, it is not mandatory to secure copyright protection for your work. According to US copyright law, your work is automatically protected the moment it is fixed in a tangible form.</div>
                              <div className="SupportFaqH3">However, if your copyright is infringed, you must register your work before filing a lawsuit. Registering your copyright prior to any infringement allows you to recover certain types of damages. It's considered best practice to register any significant work before releasing it to the public.</div>
                              <div className="SupportFaqH3">For more details on how to register your work with the USCO, visit their website at:&nbsp;<a href="https://www.copyright.gov/registration" target="_blank" style={{textDecoration:'underline'}} className="SupportFaqH3">https://www.copyright.gov/registration</a>.</div>
                              
                              <img src={FAQMinusIcon} style={{width:'0.8em',height:'3px',right:'2em',top:'1.2em',position:'absolute',cursor:'pointer'}} onClick={()=>setFaq2(!faq2)}/>
                          </div>
                      </div>
                  }

                 {
                      !faq3 && 
                      <div className="SupportFaq" style={{cursor:'pointer'}} onClick={()=>{setFaq3(!faq3);}}>
                        <div className="SupportFaqH2"> What royalty % do I get to keep?</div>
                      <img src={FAQPlusIcon} style={{width:'0.8em',height:'0.8em',right:'2em',top:'1.2em',position:'absolute'}}/>
                      </div>
                  }

                  {
                      faq3 && 
                      <div  style={{zIndex:'1'}}>
                          <div className="SupportFaq" >
                             <div onClick={()=>setFaq3(!faq3)} style={{cursor:'pointer'}} className="SupportFaqH2">What royalty % do I get to keep?</div>
                             <div className="SupportFaqH3" style={{color:'#000000'}}>
                             At N3RVE, there are no middle men. You keep 100% of the royalty distributions that come from the DSP platforms that your music is distributed to
                              </div>
 
                              <img src={FAQMinusIcon} style={{width:'0.8em',height:'3px',right:'2em',top:'1.2em',position:'absolute',cursor:'pointer'}} onClick={()=>setFaq3(!faq3)}/>
                          </div>
                      </div>
                  }

{
                      !faq4 && 
                      <div className="SupportFaq" onClick={()=>{setFaq4(!faq4);}} style={{cursor:'pointer'}}>
                   <div className="SupportFaqH2">How many tracks can I have on an album?</div>
                      <img src={FAQPlusIcon} style={{width:'0.8em',height:'0.8em',right:'2em',top:'1.2em',position:'absolute'}}/>
                      </div>
                  }

                  {
                      faq4 && 
                      <div  style={{zIndex:'1'}}>
                          <div className="SupportFaq">
                             <div onClick={()=>setFaq4(!faq4)} style={{cursor:'pointer'}} className="SupportFaqH2">How many tracks can I have on an album?</div>
                              <div className="SupportFaqH3" style={{color:'#000000'}}>
                              Typically, albums contain 10-15 tracks, but you can have up to 50 
                              </div>
                              <div className="SupportFaqH3">If your album exceeds 50 tracks, you'll need to submit it as multiple albums. Generally, it's best to keep an album under 80 minutes in total length. We can't ensure successful delivery for albums that exceed 5 hours of content.</div>
                              <img src={FAQMinusIcon} style={{width:'0.8em',height:'3px',right:'2em',top:'1.2em',position:'absolute',cursor:'pointer'}} onClick={()=>setFaq4(!faq4)}/>
                          </div>
                      </div>
                  }

{
                      !faq5 && 
                      <div className="SupportFaq" onClick={()=>{setFaq5(!faq5);}} style={{cursor:'pointer'}}>
                   <div className="SupportFaqH2">Can I transfer releases from another distributor?</div>
                      <img src={FAQPlusIcon} style={{width:'0.8em',height:'0.8em',right:'2em',top:'1.2em',position:'absolute'}}/>
                      </div>
                  }

                  {
                      faq5 && 
                      <div  style={{zIndex:'1'}}>
                          <div className="SupportFaq">
                             <div onClick={()=>setFaq5(!faq5)} style={{cursor:'pointer'}} className="SupportFaqH2">Can I transfer releases from another distributor?</div>
                              <div className="SupportFaqH3" style={{color:'#000000'}}>
                              As long as you are not under a current agreement that restricts are catalog distribution rights, then you are free to make any transfers that you’d like and can start uploading your music to your account today. The process is very simple, the steps are listed below:
                              </div>
                              <div style={{display:'flex',flexDirection:'row'}}>
                                <div className="SupportFaqH3" style={{width:'1%',marginLeft:'2em',marginRight:'0.5em'}}>1.</div>
                                <div className="SupportFaqH3">Input your listings to N3RVE with the exact same metadata that was previously used. It is critical that the metadata on your new release is an exact 1:1 match </div>
                              </div>
                              <div style={{display:'flex',flexDirection:'row'}}>
                                <div className="SupportFaqH3" style={{width:'1%',marginLeft:'2em',marginRight:'0.5em'}}>2.</div>
                                <div className="SupportFaqH3">Upload your music with the exact same audio file that was previously used</div>
                              </div>
                              <div style={{display:'flex',flexDirection:'row'}}>
                                <div className="SupportFaqH3" style={{width:'1%',marginLeft:'2em',marginRight:'0.5em'}}>3.</div>
                                <div className="SupportFaqH3">Submit and go live</div>
                              </div>
                              <div style={{display:'flex',flexDirection:'row'}}>
                                <div className="SupportFaqH3" style={{width:'1%',marginLeft:'2em',marginRight:'0.5em'}}>4.</div>
                                <div className="SupportFaqH3">4. Contact your old distributor and request takedowns of your music from their platform.<span style={{fontWeight:'500'}}> Make sure to only do this AFTER you have confirmed the successful linking and transfer of stream counts of your tracks</span>
    <br/>
    Please note that tracks must be delivered to Spotify with 5 days lead time to allow their systems to recognize the duplicative content, and transfer over stream counts.</div>
                              </div>
                              <img src={FAQMinusIcon} style={{width:'0.8em',height:'3px',right:'2em',top:'1.2em',position:'absolute',cursor:'pointer'}} onClick={()=>setFaq5(!faq5)}/>
                          </div>
                      </div>
                  }

{
                      !faq6 && 
                      <div className="SupportFaq" onClick={()=>{setFaq6(!faq6);}} style={{cursor:'pointer'}}>
                   <div className="SupportFaqH2">Can I upload AI produced music?</div>
                      <img src={FAQPlusIcon} style={{width:'0.8em',height:'0.8em',right:'2em',top:'1.2em',position:'absolute'}}/>
                      </div>
                  }

                  {
                      faq6 && 
                      <div  style={{zIndex:'1'}}>
                          <div className="SupportFaq">
                             <div onClick={()=>setFaq6(!faq6)} style={{cursor:'pointer'}} className="SupportFaqH2">Can I upload AI produced music?</div>
                              <div className="SupportFaqH3" style={{color:'#000000'}}>
                              In order to prevent any violations of our Terms Of Service (Link to our terms page), N3RVE does not permit AI produced music for distribution at this time. Even if the A.I. generator you are using permits commercial use, there is no way to ensure or enforce sounds or rights compliance.
                              </div>
                              <div className="SupportFaqH3">If you have any other questions or need additional assistance, please submit a <a href="https://support.unitedmasters.com/hc/en-us/requests/new" target="_blank" style={{textDecoration:'underline'}} className="SupportFaqH3">request for support.</a></div>
                              <img src={FAQMinusIcon} style={{width:'0.8em',height:'3px',right:'2em',top:'1.2em',position:'absolute',cursor:'pointer'}} onClick={()=>setFaq6(!faq6)}/>
                          </div>
                      </div>
                  }

                </div>

                <div className="infoDescHeader">
                SUBMISSION PROCESS
                </div>

                <div style={{display:'flex',flexDirection:'column',width:'100%',justifyContent:'flex-start',zIndex:'1'}}>
                    {/**PENDING */}

                    {
                      !faq16 && 
                      <div className="SupportFaq" onClick={()=>{setFaq16(!faq16);}} style={{cursor:'pointer'}}>
                   <div className="SupportFaqH2">Going Live</div>
                      <img src={FAQPlusIcon} style={{width:'0.8em',height:'0.8em',right:'2em',top:'1.2em',position:'absolute'}}/>
                      </div>
                  }

                  {
                      faq16 && 
                      <div  style={{zIndex:'1'}}>
                          <div className="SupportFaq">
                             <div onClick={()=>setFaq16(!faq16)} style={{cursor:'pointer'}} className="SupportFaqH2">Going Live</div>
                             <div className="SupportFaqH3">After your release is approved and sent to music platforms, most services typically need 1-2 days to make it live. However, we can't promise it will be available within this period, as some services may require more time. Additionally, Apple may select a small percentage of releases for an internal review, which could take up to 15 business days. To ensure your release is available on your chosen date, we suggest submitting your content at least 3 weeks in advance. </div>
                              <img src={FAQMinusIcon} style={{width:'0.8em',height:'3px',right:'2em',top:'1.2em',position:'absolute',cursor:'pointer'}} onClick={()=>setFaq16(!faq16)}/>
                          </div>
                      </div>
                  }
                </div>

                {
                    !feedback &&
                    <div>
                         <div className="infoDesc" style={{marginTop:'6.5em'}}>
                            Was this article helpful?
                            </div>

                            <div style={{display:'flex',flexDirection:'row'}}>
                                <div className="helpfulBtn" onClick={()=>setFeedback(true)}>
                                    YES
                                </div>

                                <div className="helpfulBtn" onClick={()=>setFeedback(true)}>
                                    NO
                                </div>
                            </div>
                    </div>
                }

                {
                    feedback &&
                    
                         <div className="infoDesc" style={{marginTop:'8.5em'}}>
                           Thank you for your feedback
                            </div>

                         
                    
                }
               
            </div>

        </div>
        
        
       
    </div>
    )
}


export default ReleaseMusic;